import {
  Box,
  Flex,
  HStack,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { FiDatabase } from "react-icons/fi";
import PaymentVerifiedIcon from "./PaymentVerifiedIcon";
import { BsStarFill } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";

export default function JobCard({
  title,
  verified,
  description,
  paymentVerified,
  spent,
  location,
  reviews,
  last,
}) {
  return (
    <Box
      px={{ base: 2, lg: 10 }}
      py={{ base: 4, lg: 10 }}
      borderBottom={last ? "0" : "1px solid #c5c5c5"}
    >
      <Flex
      gap={5}
        alignItems="center"
        justifyContent="space-between"
        display={{ base: "none", lg: "flex" }}
        
      >
        <HStack gap={6} alignItems="center" maxW={{xl:"75%"}}>
          <Text fontSize={"21px"} fontWeight="semibold" cursor="pointer">
            {title}
          </Text>
          {verified && (
            <Box>
              <Image src="/images/verified.png" width="80px" />
            </Box>
          )}
        </HStack>
        <HStack
          alignItems="center"
          color="#888"
          display={{ base: "none", xl: "flex" }}
          fontWeight="semibold"
        >
          <FiDatabase />
          <Text>Fixed Project</Text>
        </HStack>
      </Flex>
      <Text
        fontSize={{ base: "14px", lg: "21px" }}
        display={{ base: "block", lg: "none" }}
        fontWeight="semibold"
        pr={5}
        cursor='pointer'
      >
        {title}
      </Text>
      <Flex justifyContent={"space-between"} flexDir={{ base: "column" }}>
        <Flex gap={5} justifyContent={"space-between"}>
          <Stack color="#888" gap={2} my={1} maxW={{xl:"75%"}}>
            <Text fontSize={{ base: "8px", lg: "16px" }} fontWeight="semibold">
              Posted 2 Days ago
            </Text>
            <Box fontWeight="semibold" fontSize={{ base: "11px", lg: "16px" }}>
              {description}
            </Box>
          </Stack>
          <Text
            fontSize={{ base: "14px", lg: "24px" }}
            fontWeight="semibold"
            display={{ base: "none", xl: "block" }}
          >
            $42 - $250
          </Text>
        </Flex>
        <Flex
          gap={{base:2,md:4}}
          alignItems="center"
          pt={2}
          fontSize={{ base: "9px", lg: "16px" }}
          fontWeight="semibold"
        >
          <HStack gap={{ lg: 2 }}>
            <PaymentVerifiedIcon verified={paymentVerified} />
            <Text fontWeight="semibold"           color="#888">Payment Verified</Text>
          </HStack>
          <Flex color={reviews ? "#ffbe5b" : "#888"} gap={1}>
            <BsStarFill />
            <BsStarFill />
            <BsStarFill />
            <BsStarFill />
            <BsStarFill />
          </Flex>
          <Text color="black">
            ${spent}
            <Box as="span" color="#888" px={1}>
              Spent
            </Box>
          </Text>
          <HStack>
            <Box as="span" color="brand.500">
              <MdLocationOn />
            </Box>
            <Text color="#888">{location}</Text>
          </HStack>
        </Flex>
        <Flex
          justifyContent={{ base: "space-between" }}
          display={{ base: "flex", xl: "none" }}
          pt={4}
        >
          <HStack
            alignItems="center"
            color="#888"
            fontWeight="semibold"
            fontSize={{ base: "10px", lg: "16px" }}
          >
            <FiDatabase />
            <Text>Fixed Project</Text>
          </HStack>
          <Text fontSize={{ base: "14px", lg: "24px" }} fontWeight="semibold">
            $42 - $250
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
}
